import script from "./Images.vue?vue&type=script&lang=ts&setup=true"
export * from "./Images.vue?vue&type=script&lang=ts&setup=true"

import "./Images.vue?vue&type=style&index=0&id=44ff51f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ff51f6"]])

export default __exports__